// extracted by mini-css-extract-plugin
export default {"label_extra_value":"LabelWithExtraValue_label_extra_value__kA9v7"};